/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { DataCitiesManager } from 'types/user.types';

export const formatCitiesManager = (dataCitiesManager: DataCitiesManager[]) => {
  return dataCitiesManager?.map((cityManager) => ({
    label: cityManager.name,
    value: cityManager.id,
  }));
};
